import { Component } from '@angular/core';
import { CSE_STOCK } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'pace-confirmation-cse-stock',
    templateUrl: './confirmation-cse-stock.component.html',
    styleUrls: ['./confirmation-cse-stock.component.scss'],
})
export class ConfirmationCseStockComponent {
    public modalResult = new Subject<boolean | CSE_STOCK>();
    public constructor(public readonly modalInstance: BsModalRef) {}

    public openOtherStock(): void {
        this.modalResult.next(CSE_STOCK.OTHER_STOCK);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public openBootStock(): void {
        this.modalResult.next(CSE_STOCK.BOOT_STOCK);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public onNoClicked(): void {
        this.modalResult.next(false);
        this.modalResult.complete();
        this.modalInstance.hide();
    }
}
